import React from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#1a2542] text-white py-12" data-id="element-35">
      <div className="container mx-auto px-4" data-id="element-36">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8" data-id="element-37">
          <div className="mb-6 md:mb-0" data-id="element-38">
            <div className="relative h-14 mb-4" data-id="element-39">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vtTMidWxEm18GMUDR2LR8M/TC_Lawyering_Logo.png" alt="The Concierge Lawyering Logo" className="h-14 mix-blend-screen" data-id="element-40" />
            </div>
            <p className="text-sm text-gray-300 max-w-md" data-id="element-41">
              Combining the precision of top-tier legal advisory with the
              personalized approach of a boutique consultancy.
            </p>
          </div>
          <div className="flex flex-col items-center md:items-end" data-id="element-42">
            <div className="flex items-center mb-2" data-id="element-43">
              <Mail size={16} className="mr-2 text-[#c8a951]" data-id="element-44" />
              <a href="mailto:clientaffairs@tclawyering.com" className="text-sm hover:text-[#c8a951] transition-colors duration-300" data-id="element-45">
                clientaffairs@tclawyering.com
              </a>
            </div>
            <div className="flex space-x-6 mt-4" data-id="element-46">
              <Link to="/about" className="text-xs uppercase tracking-wider hover:text-[#c8a951] transition-colors duration-300" data-id="element-47">
                Who We Are
              </Link>
              <Link to="/services" className="text-xs uppercase tracking-wider hover:text-[#c8a951] transition-colors duration-300" data-id="element-48">
                What We Do
              </Link>
              <Link to="/contact" className="text-xs uppercase tracking-wider hover:text-[#c8a951] transition-colors duration-300" data-id="element-49">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-700 pt-6 text-center" data-id="element-50">
          <p className="text-xs text-gray-400" data-id="element-51">
            © {currentYear} The Concierge Lawyering. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
};
export default Footer;